import { withStyles } from '@material-ui/core/styles';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { checkIsSameDayDelivery } from '@dataGrid/components/cellRenderer';
import ToolTip from '../../../common/StyledToolTip';

const styles = (theme) => ({
  alignMiddle: {
    verticalAlign: 'middle',
    fontSize: 16,
    paddingLeft: 4,
    color: theme.missedVoidedPickupFillColor
  }
});

const EtaEtdRenderer = ({ params, fieldName, classes }) => {
  const { valueFormatted, data, context } = params;
  if (!valueFormatted) return null;
  return (
    <>
      {valueFormatted}
      {!checkIsSameDayDelivery(data?.[fieldName], context?.planDate) && (
        <ToolTip title="Next day delivery">
          <InfoOutlinedIcon className={classes.alignMiddle} />
        </ToolTip>
      )}
    </>
  );
};

export default withStyles(styles)(EtaEtdRenderer);
